import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import LinkStyled from "shared/ui/LinkStyled";
import PageTitle from "shared/ui/PageTitle";
import DashboardBox from "features/dashboard/components/DashboardBox";
import PriceTable from "../components/PriceTable";

const SUBSCRIPTIONS = [
    {
        name: "Brio Abonament Învățător",
        price: 400,
        students_no: 30,
        icon: "fal user-pen",
        bgColor: "dark",
        credits: [
            {name: "teste matematică", credits: "NELIMITAT"},
            {name: "teste limba română", credits: "NELIMITAT"},
            {name: "teste istorie", credits: "NELIMITAT"},
            {name: "teste fizică", credits: "NELIMITAT"},
            {name: "teste chimie", credits: "NELIMITAT"},
            {name: "teste biologie", credits: "NELIMITAT"},
            {name: "teste geografie", credits: "NELIMITAT"},
            {name: "teste literație limba română", credits: "NELIMITAT"},
            {name: "teste literație digitală", credits: "NELIMITAT"},
        ]
    },
    {
        name: "Brio Abonament Profesor",
        price: 1000,
        students_no: 90,
        icon: "fal chalkboard-user",
        bgColor: "dark",
        credits: [
            {name: "teste matematică", credits: "NELIMITAT"},
            {name: "teste limba română", credits: "NELIMITAT"},
            {name: "teste istorie", credits: "NELIMITAT"},
            {name: "teste fizică", credits: "NELIMITAT"},
            {name: "teste chimie", credits: "NELIMITAT"},
            {name: "teste biologie", credits: "NELIMITAT"},
            {name: "teste geografie", credits: "NELIMITAT"},
            {name: "teste literație limba română", credits: "NELIMITAT"},
            {name: "teste literație digitală", credits: "NELIMITAT"},
        ],
        extra: "test BAC/ Evaluare Națională per elev/ lună"

    },
    {
        name: "Brio Abonament Școală/ Liceu",
        price: 2500,
        icon: "fal graduation-cap",
        students_no: "nelimitat",
        bgColor: "dark",
        credits: [
            {name: "teste matematică", credits: "NELIMITAT"},
            {name: "teste limba română", credits: "NELIMITAT"},
            {name: "teste istorie", credits: "NELIMITAT"},
            {name: "teste fizică", credits: "NELIMITAT"},
            {name: "teste chimie", credits: "NELIMITAT"},
            {name: "teste biologie", credits: "NELIMITAT"},
            {name: "teste geografie", credits: "NELIMITAT"},
            {name: "teste literație limba română", credits: "NELIMITAT"},
            {name: "teste literație digitală", credits: "NELIMITAT"},
        ],
        extra: "test BAC/ Evaluare Națională per elev/ lună"
    },
]

const Subscriptions = () => {

    return (
        <Box component="main">
            <PageTitle>
                Cumpără un abonament*
            </PageTitle>
            <Typography variant="body1">
                Testele Brio® adaptate la noile standarde de evaluare naționale (clasele I - VIII) îți arată nivelul (real) de cunoștințe al elevului prin intermediul raportului detaliat de evaluare. Îți spune care sunt capitolele la care elevul excelează și care sunt cele care necesită îmbunătățiri, monitorizând progresul prin retestare.
            </Typography>
            <Typography variant="body1"><b>Telefon:</b> 0751.237.170 (10:00 - 17:00, L-V)</Typography>
            <Grid container spacing={3} direction="row" justifyContent="flex-start" alignItems="stretch" mt="0">
                {SUBSCRIPTIONS.map(
                    (product, index) =>
                        <Grid item xs={12} md={6} lg={4} xl={4} key={index}>
                            <DashboardBox
                                type="jsx"
                                number={0}
                                title={product.name}
                                icon={product.icon}
                                bgColor={product.bgColor}
                            >
                                <>
                                    {product.credits.length > 0 && (
                                        <Box mt={2}>
                                            {product.credits.map((credit: any, index: any) => (
                                                <Box display="flex" justifyContent="space-between" key={index}>
                                                    <Typography variant="body1" mb={2} mr={2}>
                                                        {credit.name}
                                                    </Typography>
                                                    <Typography variant="h4" mb={2}>
                                                        {credit.credits}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </>
                                <>
                                    {product.extra && (
                                        <Typography><span style={{fontSize: "2rem"}}> 1 </span>{product.extra}</Typography>
                                        )
                                    }
                                </>
                                <Box>
                                    <Divider sx={{ borderColor: "primary.light", marginBottom: 3, marginTop: 1 }} />
                                    <Box display="flex" justifyContent="space-between" width="100%" mt={2}>
                                        <Typography variant="h2">
                                            {product.price}
                                            <span style={{fontSize: "16px"}}>lei/lună</span>
                                        </Typography>
                                        <Typography variant="body1">sau</Typography>
                                        <Typography variant="h2">
                                            {product.price * 10}
                                            <span style={{fontSize: "16px"}}>lei/anual</span>
                                        </Typography>
                                    </Box>
                                </Box>
                            </DashboardBox>
                        </Grid>
                )}
            </Grid>
            <Typography variant="body2" mt={2}>* Prețurile afișate nu includ TVA.</Typography>
            <Typography variant="body2">* Școlile din mediul rural pot beneficia de o reducere între 10% și 30% din
                prețurile afișate, în funcție de anumite condiții. Discount-ul nu se aplică școlilor care au obținut
                finanțare prin programul PNRAS. Aici informații legate de programul PNRAS:
                <LinkStyled to="/pnras"> https://brio.school/pnras</LinkStyled></Typography>
            <Typography variant="h3" mt={3} mb={3}>Opțiuni* – structură prețuri teste școlare</Typography>
            <PriceTable />
        </Box>
    )
}

export default Subscriptions;